import client from "@/apis/client";
import {
  type ClassroomScreenScreen,
  type ClassroomScreenInput,
} from "@/services/fobizzToolsApi";

export async function show(id: string): Promise<ClassroomScreenScreen> {
  const response = await client.get(`/api/teaching_board/screens/${id}`);
  return response.data;
}

export async function create(
  attrs: Partial<ClassroomScreenInput>
): Promise<ClassroomScreenScreen> {
  const body = {
    screen: attrs,
  };

  const response = await client.post(`/api/teaching_board/screens`, body);
  return response.data;
}

export async function update(
  id: string,
  attrs: Partial<ClassroomScreenInput>
): Promise<Screen> {
  const body = {
    screen: attrs,
  };

  const response = await client.patch(
    `/api/teaching_board/screens/${id}`,
    body
  );
  return response.data;
}
